import { HalfStarIcon } from '@euler/app/components/icons/HalfStarIcon';
import { StarIcon } from '@euler/app/components/icons/StarIcon';
import { HStack } from '@euler/components/layout/Stack';
import { range } from 'ramda';
import { memo } from 'react';
import { Text, ViewProps } from 'react-native';

interface Props extends ViewProps {
  maxValue: number;
  value?: number;
  icon?: 'default' | 'face';
  labelType?: 'default' | 'satisfaction' | 'none';
  iconSize?: number;
}

const DEFAULT_LABELS = ['极差', '差', '一般', '好', '很好'];
const FACE_LABELS = ['非常不满意', '不满意', '一般', '满意', '非常满意'];

export function getRatingLabel({
  value = 0,
  type = 'default',
}: {
  value?: number;
  type?: 'default' | 'satisfaction';
}) {
  const labels = type === 'satisfaction' ? FACE_LABELS : DEFAULT_LABELS;
  return labels[Math.max(0, Math.floor(value) - 1)] || '';
}

export const Rating = memo(
  ({
    maxValue,
    icon,
    iconSize,
    labelType = 'none',
    value = 0,
    ...props
  }: Props) => {
    const scale = 5 / maxValue;
    value = value * scale;

    const label = getRatingLabel({
      value,
      type:
        icon === 'face' || labelType === 'satisfaction'
          ? 'satisfaction'
          : 'default',
    });

    const values = range(1, 6);

    return (
      <HStack justifyContent="flex-start" {...props}>
        {values.map(x =>
          x - value > 0 && x - value < 1 ? (
            <HalfStarIcon size={iconSize} key={x} />
          ) : x > value ? (
            <StarIcon fill="#ddd" size={iconSize} key={x} />
          ) : (
            <StarIcon size={iconSize} key={x} />
          ),
        )}
        {labelType !== 'none' && <Text>{label}</Text>}
      </HStack>
    );
  },
);
